import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { StandService } from "app/stand/stand.service";
import { StandHeaderComponent } from "app/stand/components/header/stand-header.component";
import { StandFreeComponent } from "./stand-free.component";
import { StandFooterComponent } from "app/stand/components/footer/stand-footer.component";
import { InfoBarMobileComponent } from "app/stand/components/info-bar/info-bar-mobile/info-bar-mobile.component";
import { StandLayoutEnum } from "app/stand/stand.enums";

const pagesData = {
  isCacheable: true,
  breadcrumb: $localize`Online Stand`,
  layout: StandLayoutEnum.standFree
}

const routes: Routes = [
  {
    path: '',
    component: StandFooterComponent,
    outlet: 'footerOutlet',
    data: {
      shouldReuseOnSlide: false
    },
  },
  {
    path: '',
    component: InfoBarMobileComponent,
    outlet: 'mobileinfoBarOutlet',
    data: {
      shouldReuseOnSlide: false
    },
  },
  {
    path: ':companySlug',
    component: StandFreeComponent,
    data: {
      breadcrumb: 'subhall',
      shouldReuseOnSlide: false
    },
    resolve: {
      resolvedData: StandService
    },
    children: [{
      path: '',
      component: StandHeaderComponent,
      outlet: 'topOutlet',
      data: {
        shouldReuseOnSlide: false
      },
    },
    {
      path: '',
      pathMatch: 'full',
      loadComponent: () => import('./dashboard-free/dashboard-free.component').then(c => c.DashboardFreeComponent),
      data: pagesData
    },
    {
      path: 'news',
      pathMatch: 'full',
      loadComponent: () => import('./get-business-access/get-business-access.component').then(c => c.GetBusinessAccessComponent),
      data: pagesData
    },
    {
      path: 'products',
      pathMatch: 'full',
      loadComponent: () => import('./get-business-access/get-business-access.component').then(c => c.GetBusinessAccessComponent),
      data: pagesData
    }]
  }
]
@NgModule({
    imports: [
        RouterModule.forChild(routes)
    ],
    exports: [RouterModule]
})
  export class StandFreeRoutingModule {
  }
